/**
 * image -> string = imagem de fundo
 * title -> string = title
 * textClassName -> string = classe customizada para o title
 */
import React from "react";
import './CardImgDistribution.css'
import getImage from "../../useFull/getImage";

const CardImgDistribution = props => {
    const { image, title, textClassName } = props

    const img = getImage('card-distribution-images', image);
    
    return img && (
        <div className="container-card-img-distribution" style={{ backgroundImage: `url(${img})` }}>
            <span dangerouslySetInnerHTML={{ __html: title }} className={`text-title-secondary white100 page-title ${textClassName}`}></span>
        </div>
    )
}

export default CardImgDistribution